import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";
import GridControl from '../../../../components/Controls/gridControl.js'
import MultiSelectDropdown from '../../../Controls/multiselectdropdown';

const DriverSearch = (props) => {
    const [DriverSearchGridResponse, setDriverSearchGridResponse] = useState("");
    
    const { loginData } = useSelector((store) => store.login);
    const { FamilyData, DispatchGridColorsData} = useSelector((store) => store.combinedata);
    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const [showDriverSearchAlert, setDriverSearchAlert] = useState(false);
    const [apiRowData, setApiRowData] = useState(DispatchGridColorsData[0]);
    const [apiColData, setApiColData] = useState(DispatchGridColorsData[1]);
    const [driverSearchAlertObj, setDriverSearchAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [FamilyGroupsSingleSelect, SetFamilyGroupsMultiSelect] = useState({ options: [], selectedValues: [], placeholder: "Family Filter", displayValue: "name", emptyRecordMsg: "N/A", id: "DriverSearchGridFamilySelect", className: "DriverSearchGridFamilySelect", singleSelect: true, showCheckbox: false, TriggerSelectEventOnDataPopulate: false, styles: { width: "150px", marginLeft: "10px" } });
    const [familyDropdown, setFamilyDropdown] = useState(0);
    const [ToolboxValues, SetToolboxValues] = useState({
        ddlFamily:"",txtVehicleNumber:""
    });
    const [DriverSearchGridControlOptions, SetDriverSearchGridControlOptions] = useState({
        height: '300',
        heightoffset: 600,
        calculateHeight: true,
        pagination: true,
        paginationMode: "local",
        paginationSize: 100,
        paginationSizeSelector: [100, 200, 300, 400, 500],
        selectable: 1,
        reactiveData: true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder: "No Data Available",
        selectableRangeMode: "click",
        GridName: "driverSearchGrid",
        clipboard: false,
        paginationCounter: "rows",
        movableColumns: true,
        vDefaultGridName: "DriverSearchGrid_grdControl",
        index:"id",
        bSysUser: 1,
        autoColumns: true,
        sortCondition: true,
        intervalEnable: false,
        persistence:false,
        bWebApplySettingToAll: true,
        ID_Column: "iDriverID",
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '',
        footerElementHandles: function(){},
        tableDoubleClickFunc: function(table, row) {
        },
        rowSelectionChangeHandle: function(data){ 
        },
        AlwaysHiddenColumns: ["Other"]
    });

    const xCancelSourceForGrid = useRef(null);
    const familyIDRef = useRef(0);
    const vehicleSelection = useRef(null);

    const handleClose = () =>  props.setDriverSearchComponentLoad(false);
    const handleShow = () => props.setDriverSearchComponentLoad(true);

    const handleDriverSearchAlertClose = () => {
        setDriverSearchAlert(false);
        UnMountDriverSearchComponent();
    };

    const UnMountDriverSearchComponent = () => {
        if (props.driversearchComponentLoaded) {
            props.setDriverSearchComponentLoad(false);
        }
    };

    const handleVehicleOnchange = (event) => {        
        vehicleSelection.current = event.target.value;
    };

    const handleFamilyOnChange = (val) => {
        try{
            // console.log(val);
            setFamilyDropdown(parseInt(val[0]));
        }
        catch(err){console.log(err);}
    };

    const handleDriverSearch = () => {
      PrepareDriverSearchRequest();
    };

    const driverTableReloaded = () => {
        
    };

    const PrepareDriverSearchRequest = async (familyID = 0) => {
        try{
            setShowGridLoader(true);
            xCancelSourceForGrid.current = APICom.GenerateSource();
            const data = {
                "searchtext": vehicleSelection.current,
                "FamilyID": (familyID !== 0 ? familyID : familyDropdown),
                "user_id": loginData.iUserID
            }
            let response = await APICom.fetchData("main", "GridData/GetDriverSearchGridData", "post", {}, data, xCancelSourceForGrid.current);
            if (response.error === "") {
                setDriverSearchGridResponse({"data":response.data});
            }
            setShowGridLoader(false);
        }
        catch(err){console.log(err); setShowGridLoader(false);}
    };

    useEffect( () => {
        try{
            if (!(props.GridRowData) || props.GridRowData.length <= 0) {
                setDriverSearchAlertObj({ ...driverSearchAlertObj, alertTitle: 'No trip selected', alertMsg: 'No request selected to perform driver search.' });
                setDriverSearchAlert(true);
            }
            else {
                let initialFamilyGroupSelected = [];
                let optsFamily = [];
                for (let i = 0; i < FamilyData.length; i++) {
                    if (i === 0) { initialFamilyGroupSelected.push(FamilyData[i]["iATSPGroupID"].toString()); }
                    optsFamily.push({ "name": FamilyData[i]["vATSPGroupName"], "id": FamilyData[i]["iATSPGroupID"] })
                }
                SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{ options: optsFamily } });
                // setFamilyDropdown(FamilyData[0]["iATSPGroupID"]);
                vehicleSelection.current = (props.GridRowData[0].VREQ && props.GridRowData[0].VREQ !== "None") ? props.GridRowData[0].VREQ : '';
                props.setDriverSearchComponentLoad(true);
                familyIDRef.current = FamilyData[0]["iATSPGroupID"];
                PrepareDriverSearchRequest(FamilyData[0]["iATSPGroupID"]);
            }
        }
        catch(err){console.log(err);}
    }, []);

    useEffect(()=>{
        try{
            if(familyDropdown !== 0 && familyIDRef.current !== familyDropdown)
            {
                PrepareDriverSearchRequest(familyDropdown);
                familyIDRef.current = parseInt(familyDropdown);
            }
        }
        catch(err){console.log(err);}
    }, [familyDropdown])
    return (
        <>

            {props.driversearchComponentLoaded ? <Modal show={props.driversearchComponentLoaded} onHide={handleClose} backdrop={"static"} keyboard={true} size="xl" centered>
                <Modal.Header closeButton className="activate_dialog_header_bgcolor">
                    <Modal.Title className="activate_dialog_title_color user-select-none">Driver Search</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="m-0">
                        <Col>
                            <Row>
                                <Form.Group className="mb-3 col-md-6">
                                    <Form.Label className="user-select-none">Affiliate Group</Form.Label>
                                    <MultiSelectDropdown controlid="ddlFamily" options={FamilyGroupsSingleSelect} singleselect="true" SelectionChangeCallback={handleFamilyOnChange} />
                                </Form.Group>
                                <Form.Group className="mb-3 col-md-6">
                                    <Form.Label className="user-select-none">Vehicle #</Form.Label>
                                    <Form.Control type="text" controlid="txtVehicleNumber" defaultValue={vehicleSelection.current}  className="txtVehicleNumber" onChange={handleVehicleOnchange}></Form.Control >
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <GridControl Data={DriverSearchGridResponse} rowColors={apiRowData} cellColors={apiColData} ReloadDataFunction={driverTableReloaded} options={DriverSearchGridControlOptions} ShowLoader={ShowGridLoader}/>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={handleDriverSearch}>
                        Search
                    </Button>
                    <Button variant="dark" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>: ""}
            {showDriverSearchAlert ? <Modal centered show={showDriverSearchAlert} onHide={handleDriverSearchAlertClose} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>{driverSearchAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{driverSearchAlertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={handleDriverSearchAlertClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>:""}
        </>
    );
};


export default DriverSearch;